import React, { useEffect, useState } from 'react'
import { ScrollView, View, Text, Pressable } from 'react-native'
import { UserAvatarMobile } from '../web/UserAvatarWeb'
import theme from '../../../theme'
import { LinealTabs } from '../customUtils/LinealTabs'
import { AdvancesList } from './AdvancesList'
import { Loader } from '../customUtils/Components/Loader'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { request_get_advances_api } from '../../services/advances_api'
import { Image } from 'expo-image'
export const AdvancesScreen = () => {
    const [loading, setLoading] = useState(true)
    const [index, setIndex] = useState(0)
    const [tabs, setTabs] = useState([
        // { name: 'Mi avance', index: 0 },
        // { name: 'Mi plan de carrera', index: 1 },
    ])
    const [userInfo, setUserInfo] = useState(null)
    const [advances, setAdvances] = useState(null)
    const [careerPlan, setCareerPlan] = useState(null)

    useEffect(() => {
        fetchData()
    }, [])
    async function fetchData() {
        try {
            //Llamado al api
            setLoading(true)
            let data = await request_get_advances_api()
            if (!data) return setIndex(-1)
            const { user_info, advances, carrer_plan } = data

            let newTabs = []

            if (user_info) setUserInfo(user_info)
            if (advances) {
                newTabs.push({ name: 'Mi avance', index: 0 })
                setAdvances(advances)
            }

            if (carrer_plan) {
                newTabs.push({ name: 'Mi plan de carrera', index: 1 })
                setCareerPlan(carrer_plan)
            }

            if (newTabs.length > 0) {
                setIndex(newTabs[0].index)
                setTabs(newTabs)
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }
    const insets = useSafeAreaInsets()

    if (loading) {
        return <Loader />
    }
    return (
        <ScrollView
            style={{ flex: 1, backgroundColor: '#F8F9FF' }}
            contentInset={{ bottom: insets.bottom }}
        >
            <View
                style={{
                    flexDirection: 'row',
                    flex: 1,
                    marginHorizontal: 20,
                    marginTop: 16,
                    marginBottom: 20,
                }}
            >
                <View style={{ flex: 1 }}>
                    {userInfo && (
                        <>
                            <Text
                                style={{
                                    color: theme.colors.colorPrimary,
                                    fontSize: 16,
                                    fontWeight: '700',
                                }}
                            >
                                {userInfo?.role || 'lalala'}
                            </Text>
                            <Text
                                style={{
                                    color: theme.colors.darkGray,
                                    fontSize: 13,
                                    fontWeight: '400',
                                    marginTop: 4,
                                }}
                            >
                                {userInfo?.full_name || ''}
                            </Text>
                            <Text
                                style={{
                                    marginTop: 16,
                                    color: theme.colors.textPrimary,
                                    fontSize: 13,
                                    fontWeight: '700',
                                }}
                            >
                                {userInfo?.store || ''}
                            </Text>
                        </>
                    )}
                </View>
                {userInfo && (
                    <UserAvatarMobile
                        style={{ width: 72, height: 72, borderRadius: 40 }}
                    />
                )}
            </View>

            {tabs.length > 0 && (
                <LinealTabs
                    tabs={tabs}
                    selectedIndex={index}
                    color={theme.colors.darkGray}
                    colorSelected={theme.colors.colorPrimary}
                    onSelectedTab={(i) => {
                        setIndex(i)
                    }}
                    gradient={false}
                    backgroundColor={['#F8F9FF', '#F8F9FF']}
                />
            )}
            <View style={{ height: 8 }} />
            {(() => {
                switch (index) {
                    case 0:
                        return <AdvancesList data={advances} />
                    case 1:
                        return <AdvancesList data={careerPlan} />
                    default:
                        return (
                            <View
                                style={{
                                    flex: 1,
                                    height: 600,
                                    justifyContent: 'center',
                                    marginHorizontal: 24,
                                    alignSelf: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Image
                                    source={require('../../../assets/advances_no_data.png')}
                                    style={{ width: 120, height: 120 }}
                                />
                                <Text
                                    style={{
                                        fontWeight: '700',
                                        marginTop: 20,
                                        color: theme.colors.textPrimary,
                                        fontSize: 16,
                                    }}
                                >
                                    Sin datos de avance
                                </Text>
                                <Text
                                    style={{
                                        fontSize: 14,
                                        color: theme.colors.darkGray,
                                        marginTop: 4,
                                        textAlign: 'center',
                                    }}
                                >
                                    {
                                        'Ocurrió un error al cargar los datos. \nVuelve a intentarlo.'
                                    }
                                </Text>

                                <Pressable onPress={() => fetchData()}>
                                    <Text
                                        style={{
                                            color: 'white',
                                            fontSize: 14,
                                            fontWeight: '700',
                                            backgroundColor:
                                                theme.colors.colorPrimary,
                                            paddingHorizontal: 24,
                                            paddingVertical: 8,
                                            borderRadius: 15,
                                            marginTop: 20,
                                        }}
                                    >
                                        Reintentar
                                    </Text>
                                </Pressable>
                            </View>
                        )
                }
            })()}
        </ScrollView>
    )
}

export const AdvanceSection = ({ title, children = null, canSlice = false }) => {
    const [showAll, setShowAll] = useState(true)

    const enhancedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { showAll })
        }
        return child
    })

    return (
        <View
            style={{
                flex: 1,
                marginTop: 24,
                marginHorizontal: 16,
                paddingBottom: 8,
            }}
        >
            <View
                style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: 12,
                }}
            >
                <Text
                    style={{
                        fontSize: 16,
                        fontWeight: '700',
                        color: theme.colors.textPrimary,
                    }}
                >
                    {title}
                </Text>

                {canSlice && (
                    <Pressable onPress={() => setShowAll((prev) => !prev)}>
                        <Text
                            style={{
                                color: theme.colors.darkGray,
                                fontSize: 15,
                                fontWeight: '700',
                            }}
                        >
                            {showAll ? 'Ver menos' : 'Ver todos'}
                        </Text>
                    </Pressable>
                )}
            </View>

            {enhancedChildren}
        </View>
    )
}
